import { useNextStep } from "nextstepjs";
import {
  setReplayActive,
  trackOnboardingEvent,
} from "@/lib/analytics/onboarding";
import { t } from "@/lib/i18n";

export const REPLAY_ONBOARDING_EVENT = "cfl:replay-onboarding-dialog";

export function ReplayTutorialControl() {
  const { startNextStep, closeNextStep } = useNextStep();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleReplay = () => {
    localStorage.removeItem("onboardingCompleted");
    localStorage.removeItem("cfl:practice-complete-tour-done");
    localStorage.removeItem("cfl:home-modes-tour-done");

    sessionStorage.removeItem("startHomeModesTour");
    sessionStorage.removeItem("continueTourOnBasecamp");
    sessionStorage.removeItem("continueTourOnPractice");
    sessionStorage.removeItem("cfl:onboarding-skip-sent");
    sessionStorage.removeItem("cfl:onboarding-complete-sent");

    try {
      closeNextStep();
    } catch {
      // closeNextStep may throw when no tour is active
    }
    setReplayActive(true);
    trackOnboardingEvent("onboarding_replay_start", {
      tour: "home",
      replay: true,
    });
    startNextStep("homeTour");
  };

  const handleOpenOnboardingDialog = () => {
    window.dispatchEvent(new CustomEvent(REPLAY_ONBOARDING_EVENT));
  };

  return (
    <button
      onClick={handleOpenOnboardingDialog}
      className="black-container text-xs px-1.5 py-0.5! uppercase flex items-center gap-2 active:scale-98 transition-all duration-300"
    >
      <img
        src="https://cdn.navalabs.io/icons/replay-icon_gfHr8W.png"
        className="size-5"
        alt="Replay tutorial"
      />
      <span className="leading-none">{t("replayTutorial.label")}</span>
    </button>
  );
}
